<template>
    <div id='BoxSideMenu' class="col-3">
        <div class='MenuStep row' v-for='(step, index) in steps' :key='index'>
            <div class='stepDesc col-8'>
                <h4>{{step.title}}</h4>
                <span>{{step.subtitle}}</span>
            </div>
            <div class='StepBubble col-4'>
                <div class='InnerBubble' :class="{'active': step.active, 'completed': step.completed, 'errors': step.errors}"></div>
                <div class='NextStep'></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default{
        name: 'BoxSideMenu',
        props: ['navSteps'],
        data(){
            return{
                steps: this.$props.navSteps
            }

        }
    }
</script>
